<soft-checkbox [value]="value" onclick="return false;">
  <label class="soft-label soft-label-right">{{ label }}</label>
</soft-checkbox>
